import { useEffect } from 'react'

export default function usePinnedHead(headRef, theadRef) {
  useEffect(() => {
    const headEl = headRef.current
    const theadEl = theadRef.current
    if (!headEl || !theadEl) return

    const rootEl = headEl.parentElement

    const pinThead = () => {
      const tableEl = theadEl.parentElement
      const offset = headEl.getBoundingClientRect().bottom - tableEl.getBoundingClientRect().top
      const max = tableEl.offsetHeight - theadEl.offsetHeight
      theadEl.style.transform = `translate3d(0, ${Math.max(0, Math.min(offset, max))}px, 0)`
    }

    const observer = new ResizeObserver(() => {
      rootEl.style.setProperty('--pinned-head-height', `${headEl.offsetHeight}px`)
      pinThead()
    })
    observer.observe(headEl)
    observer.observe(theadEl.parentElement)

    window.addEventListener('scroll', pinThead, true)
    return () => {
      observer.disconnect()
      window.removeEventListener('scroll', pinThead, true)
    }
  }, [headRef, theadRef])
}
